import React from "react";
import ContactSection from "../components/core/ContactSection";
import Footer from "../components/common/Footer";

const Contact = () => {
	return (
		<>
			<ContactSection />
			<Footer />
		</>
	);
};

export default Contact;
